import React from 'react';
import Airbuds from '../assets/Buds';
import { Link } from 'react-router-dom';
import  MerryChristmas from '../assets/Festive.Js';
import Jumia from '../assets/Jumia';
import Jvid from '../assets/JBLvid';
import JBL from '../assets/JBL';

const Home = (props) => {
  return (
    <div>
         {props.bought && <div class="flex w-96 shadow-lg rounded-lg fixed z-20 top-6 right-5">
    <div class="bg-green-600 py-4 px-6 rounded-l-lg flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="text-white fill-current" viewBox="0 0 16 16" width="20" height="20"><path fill-rule="evenodd" d="M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"></path></svg>
    </div>
    <div class="px-4 py-6 bg-white rounded-r-lg flex justify-between items-center w-full border border-l-transparent border-gray-200">
      <div>Success alert</div>
      <button
      onClick={props.setBought(false)}
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current text-gray-700" viewBox="0 0 16 16" width="20" height="20"><path fill-rule="evenodd" d="M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z"></path></svg>
      </button>
    </div>
  </div>}
          
      <section className='bg-gray-100 py-10'>
      
        <div className='container mx-auto lg:flex gap-8 items-center justify-between p-6'>
          <div className='text-center lg:text-left mb-10 lg:mb-0'>
            <h1 className='text-5xl font-bold mb-5 text-gray-800'>
              Welcome to <span className='text-blue-600'>Probud</span>
            </h1>
            <p className='text-xl text-gray-600 mb-8'>
            Power Up Anywhere, Anytime
            </p>
            <div className='flex gap-5 justify-center lg:justify-start'>
              <Link to="/Order"><button className='bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg transition duration-300 ease-in-out shadow-lg'>
                Shop Now
              </button></Link>
             <Link to="/learnMore"> <button className='bg-transparent border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-6 py-3 rounded-lg transition duration-300 ease-in-out shadow-lg'>
                Learn More
              </button></Link>
            </div>
          </div>
          
          <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-center justify-center'>
            <img 
              src="https://images.pexels.com/photos/4765366/pexels-photo-4765366.jpeg?auto=compress&cs=tinysrgb&w=600" 
              alt="Phone accessories display 1" 
              className='h-[300px] sm:h-[350px] w-full object-cover rounded-lg shadow-lg transition-transform duration-300 hover:scale-105' 
            />
            <img 
              src="https://images.pexels.com/photos/4526430/pexels-photo-4526430.jpeg?auto=compress&cs=tinysrgb&w=600" 
              alt="Phone accessories display 2" 
              className='h-[300px] sm:h-[350px] w-full object-cover rounded-lg shadow-lg transition-transform duration-300 hover:scale-105' 
            />
            <img 
              src="https://images.pexels.com/photos/3921695/pexels-photo-3921695.jpeg?auto=compress&cs=tinysrgb&w=600" 
              alt="Phone accessories display 3" 
              className='h-[300px] sm:h-[350px] w-full object-cover rounded-lg shadow-lg transition-transform duration-300 hover:scale-105' 
            />
          </div>
        </div>
      </section>
      <section className='bg-gray-100 py-10'>
  <div className='container mx-auto'>
    <div className='flex flex-col gap-4 text-center lg:text-left mb-10'>
      <h1 className='text-red-600 font-semibold text-2xl'>Featured Products</h1>
      <p className="text-4xl font-bold text-gray-800">Top Picks for You</p>
      <p className="text-lg text-gray-600">
        Explore our top-notch gadgets and electrical equipment, curated to meet your needs.
      </p>
    </div>
    
    {/* Image Section */}
    <div className='flex flex-col lg:flex-row items-center justify-center gap-6 p-4'>
      <img 
        src={Jvid} 
        alt="Product 1" 
        className='rounded-lg w-full lg:w-1/2 h-[300px] object-cover shadow-lg hover:scale-105 transition-transform duration-300' 
      />
      <img 
        src={JBL}
        alt="Product 2" 
        className='rounded-lg w-full lg:w-1/2 h-[300px] object-cover shadow-lg hover:scale-105 transition-transform duration-300' 
      />
    </div>
    <div className='grid grid-cols-3 items-center justify-between'>
      <div className='flex flex-col gap-3 items-center justify-center'>
      <span className='font-semibold'>High-Quality Gadgets</span>
      <span>Discover gadgets that offer the best performance and reliability.</span>
    </div>
    <div className='flex flex-col gap-3 items-center justify-center'>
      <span className='font-semibold'>Customer Reviews</span>
      <span>Read reviews from satisfied customers to help you make informed decisions.</span>
    </div>
    <div className='flex flex-col gap-3 items-center justify-center'>
      <span className='font-semibold'>Competitive Prices</span>
      <span>Enjoy both wholesale and retail prices for all our products.</span>
    </div>
  </div>
  </div>
</section>
<section>
  <div>
    <div>
      <h1 className='text-4xl font-bold'>Explore our categories</h1>
      <p>show all products</p>
    </div>
    <div className="grid lg:grid-cols-4 grid-cols-2 items-center justify-center gap-7 p-3 w-full">
  {
    Airbuds.map((list) => (
      <div key={list.id} className="bg-white shadow-lg rounded-lg p-4 hover:shadow-2xl transition-shadow duration-300">
        <img 
          src={list.Address} 
          alt={list.Name} 
          className='w-full h-60 object-cover rounded-lg hover:scale-105 cursor-pointer transition-transform duration-300'
        />
        <div className="mt-4">
          <p className='text-lg font-bold text-gray-700 mb-2 border-b-2 border-gray-300'>Name: {list.Name}</p>
          
        </div>
        <button className='bg-blue-500 text-white rounded-lg p-3 w-full text-lg font-medium cursor-not-allowed hover:bg-blue-600 transition-colors duration-300'>
          coming soon...
        </button>
      </div>
    ))
  }
</div>

  </div>
</section>

    </div>
  );
}

export default Home;
